import { setBusinesses, setSelectedBusiness } from '../slices/business.slice';
import { ENDPOINT, STATUS } from '../../constants/server/api';
import { fetchApiData } from '../../utils/apiUtils';

export const createBusinessPointSetting = businessPointData => async dispatch => {
  const data = await fetchApiData({
    method: 'post',
    endpoint: `${ENDPOINT.BUSINESS_POINT}/business-point-setting/create`,
    data: businessPointData,
    dispatch
  });
  return data;
};

export const getBusinessPointSettingDetail =
  (businessSlug, type = 'EARN') =>
  async dispatch => {
    const data = await fetchApiData({
      method: 'get',
      endpoint: `${ENDPOINT.BUSINESS_POINT}/business-point-setting/${businessSlug}/detail`,
      params: { type },
      dispatch
    });
    return data;
  };

export const updateBusinessPointSetting = (businessSlug, settingData) => async dispatch => {
  const data = await fetchApiData({
    method: 'put',
    endpoint: `${ENDPOINT.BUSINESS_POINT}/business-point-setting/${businessSlug}`,
    data: settingData,
    dispatch
  });
  return data;
};

export const getAllBusinessPointSettings = businessSlug => async dispatch => {
  const data = await fetchApiData({
    method: 'get',
    endpoint: `${ENDPOINT.BUSINESS_POINT}/business-point-setting/${businessSlug}`,
    dispatch
  });
  return data;
};

export const getPaginatedBusinessPointProducts =
  (
    businessSlug,
    businessPointSettingId,
    page = 1,
    perPage = 10,
    searchTerm = '',
    sortBy = 'created_at',
    sortOrder = 'desc',
    product_category_id = ''
  ) =>
  async dispatch => {
    const data = await fetchApiData({
      method: 'get',
      endpoint: `${ENDPOINT.BUSINESS_POINT}/business-point-product/pagination/${businessSlug}/list`,
      params: {
        business_point_setting_id: businessPointSettingId,
        page,
        perPage,
        s: searchTerm,
        sortBy,
        sortOrder,
        product_category_id
      },
      dispatch
    });
    return data;
  };

export const createBusinessPointProducts = productsData => async dispatch => {
  const data = await fetchApiData({
    method: 'post',
    endpoint: `${ENDPOINT.BUSINESS_POINT}/business-point-product/create`,
    data: productsData,
    dispatch
  });
  return data;
};

export const deleteBusinessPointProduct = productId => async dispatch => {
  const data = await fetchApiData({
    method: 'delete',
    endpoint: `${ENDPOINT.BUSINESS_POINT}/business-point-product/${productId}`,
    dispatch
  });
  return data;
};

export const getPaginatedProductsNotAssociatedWithBusinessPoint =
  (
    businessSlug,
    business_point_setting_id,
    page = 1,
    perPage = 10,
    searchTerm = '',
    sortBy = 'created_at',
    sortOrder = 'desc',
    product_category_id = ''
  ) =>
  async dispatch => {
    try {
      const data = await fetchApiData({
        method: 'get',
        endpoint: `${ENDPOINT.BUSINESS_POINT}/business-point-product/pagination-products/${businessSlug}`,
        params: {
          business_point_setting_id,
          page,
          perPage,
          s: searchTerm,
          sortBy,
          sortOrder,
          product_category_id
        },
        dispatch
      });
      return data;
    } catch (error) {
      return error;
    }
  };
